
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.576 11.521a4.15 4.15 0 00.313-4.16 3.93 3.93 0 00-1.407-1.59 3.693 3.693 0 00-1.994-.589c-.704 0-1.394.204-1.995.589a3.93 3.93 0 00-1.406 1.591 4.15 4.15 0 00.313 4.16c-.525.35-.992.785-1.384 1.291a1.39 1.39 0 00-.097 1.475c.083.152.193.285.326.392a1.219 1.219 0 001.41.102 1.29 1.29 0 00.375-.34 3.268 3.268 0 011.124-.95 3.12 3.12 0 011.408-.343c.488.002.969.12 1.407.343.439.224.823.548 1.125.95.116.15.263.27.43.353a1.191 1.191 0 001.187-.075c.196-.13.353-.314.454-.532a1.345 1.345 0 00-.144-1.362 5.852 5.852 0 00-1.445-1.305zm-3.076-.943c-.264 0-.522-.082-.743-.234a1.396 1.396 0 01-.495-.624 1.468 1.468 0 01-.085-.807c.048-.271.171-.522.355-.721.183-.199.418-.337.676-.397.258-.06.527-.04.774.06.247.098.46.27.614.495a1.451 1.451 0 01.162 1.323 1.418 1.418 0 01-.288.475 1.347 1.347 0 01-.443.318 1.296 1.296 0 01-.527.112zm10.45-.646a11.297 11.297 0 00-1.851-5.25 10.637 10.637 0 00-4.084-3.614A10.101 10.101 0 009.758.028 10.197 10.197 0 004.694 1.83a10.865 10.865 0 00-3.19 3.506 11.412 11.412 0 00-.886 9.366 11.005 11.005 0 002.47 4.054l6.547 6.86c.115.122.252.218.402.284a1.188 1.188 0 001.352-.283l6.522-6.861a11.004 11.004 0 002.47-4.054c.526-1.527.72-3.156.57-4.77zm-4.768 7.003L10.5 22.88l-5.682-5.944a8.445 8.445 0 01-1.878-3.101 8.745 8.745 0 01-.432-3.643A8.76 8.76 0 013.622 6.65a8.34 8.34 0 012.456-2.7A7.743 7.743 0 0110.5 2.553c1.573 0 3.112.486 4.422 1.397a8.338 8.338 0 012.451 2.689 8.759 8.759 0 011.119 3.526 8.746 8.746 0 01-.426 3.657 8.445 8.445 0 01-1.884 3.113z"}})])
          )
        }
      }
    